import React from 'react';
import type { RejectionReason } from '../../types/products.types';
import { formatRejectionReason } from '../../utils/formatRejectionReason';

interface RejectionReasonListProps {
    reasons: RejectionReason[];
}

export const RejectionReasonList: React.FC<RejectionReasonListProps> = ({ reasons }) => (
    <div className="mb-2 text-left">
        <p className="text-mp-warning font-medium mb-1">
            The following criteria were not met:
        </p>
        <ul className="list-disc list-inside text-mp-warning space-y-1">
            {reasons.map((reason, i) => (
                <li key={`${reason.rule}-${i}`}>{formatRejectionReason(reason)}</li>
            ))}
        </ul>
    </div>
);
